import { useFlag } from '@afterpaytouch/feature'
import {
  CheckoutAppSelector,
  DonationState,
  setIsDisplayDonation,
  useAppDispatch,
  useAppSelector,
  useCheckoutState,
  useDonationCampaignDetails,
  useExperiment,
  useHasSeenDonation,
  useIsAfterpayAppGiftCardFlow,
} from '..'
import { Features, DonationStatus } from '../../model'

export const donationSelector: CheckoutAppSelector<DonationState> = (state) => state.donation

export const useDonation = (): DonationState => useAppSelector(donationSelector)

export const useIsDonationNotTriggered = (): boolean => {
  const { donationStatus } = useDonation()
  const isDonationEnabled = useFlag(Features.DONATION_ENABLED)

  if (isDonationEnabled) {
    if (donationStatus !== DonationStatus.Initial) {
      return donationStatus === DonationStatus.Inactive
    }
    return false
  } else {
    return true
  }
}

export const useIsEligibleViewDonation = (): boolean => {
  const { started } = useCheckoutState()
  const donationCampaignDetails = useDonationCampaignDetails()
  const paymentUpFront = started?.paymentUpFront

  const ineligibleForDonation = donationCampaignDetails == null || !paymentUpFront

  return !ineligibleForDonation
}

export const useIsDonationEnabled = (): boolean => {
  const donationCampaignDetails = useDonationCampaignDetails()
  const { hasSeenDonation, saveToTags: saveDonationTag } = useHasSeenDonation(donationCampaignDetails?.campaignId)

  const dispatch = useAppDispatch()

  // 1. is seeing donation banner for the first time
  const { isDisplayDonation } = useDonation()

  // 2. donation eligible
  const isEligibleViewDonation = useIsEligibleViewDonation()

  // 3. not checkout afterpay app gift card flow
  const isAfterpayAppGiftCardFlow = useIsAfterpayAppGiftCardFlow()

  // 3. donation experiment on
  const donationExperiment = useExperiment('ShowDonationMessage')

  const isDonationFlagEnabled = useFlag(Features.DONATION_ENABLED)
  const areDonationFlagsOn =
    !donationExperiment.loading && ((donationExperiment.active && !donationExperiment.control) || (!donationExperiment.active && isDonationFlagEnabled))

  // if first time save it into tag
  if (!hasSeenDonation && !isDisplayDonation && isEligibleViewDonation && areDonationFlagsOn && !isAfterpayAppGiftCardFlow) {
    dispatch(setIsDisplayDonation(true))
    saveDonationTag()
  }

  return isDisplayDonation && isEligibleViewDonation && areDonationFlagsOn && !isAfterpayAppGiftCardFlow
}
